/* eslint-disable no-use-before-define */
import React from 'react';
import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import styles from './styles';
import { useTranslation } from 'react-i18next';

interface RBIAutocompleteSearchInterface {
  onChange: any;
  onChangeInput?: any;
  value: string;
  label: string;
  id: string;
  width?: number | string;
  disabled?: boolean;
  loading?: boolean;
  options: any[];
  getOptionSelected?(option: any, value: any): boolean;
}
const RBIAutocompleteSearch = ({
  onChange,
  value,
  label,
  id,
  options,
  onChangeInput,
  disabled = false,
  width = 150,
  loading = false,
  getOptionSelected,
}: RBIAutocompleteSearchInterface) => {
  const { t } = useTranslation();
  const classes = styles();
  const onChangeTrigger = (event: any, value: any) => {
    onChange(id, value);
  };
  const onInputChange = (event: any, value: any) => {
    if (onChangeInput) {
      onChangeInput(id, value);
    }
  };

  const extraProps = {};
  if (typeof getOptionSelected === 'function') {
    extraProps['getOptionSelected'] = getOptionSelected;
  }

  return (
    <Autocomplete
      id={id}
      value={value}
      style={{ width: width }}
      options={options}
      onChange={onChangeTrigger}
      onInputChange={onInputChange}
      disabled={disabled}
      data-testid={id}
      className={classes.autocomplete}
      getOptionLabel={option => option.name || ''}
      loading={loading}
      autoHighlight={true}
      noOptionsText={t`app.common.noOptions`}
      renderInput={params => (
        <TextField
          {...params}
          label={label}
          variant="outlined"
          margin="normal"
          name={id}
          size="small"
          InputProps={{
            ...params.InputProps,
            inputProps: {
              ...params.inputProps,
              role: 'textbox',
              'data-testid': `${id}-input`,
            },
          }}
        />
      )}
      renderOption={(option, { inputValue }) => {
        const matches = match(option.name, inputValue);
        const parts = parse(option.name, matches);

        return (
          <div>
            {parts.map((part, index) => (
              <span
                key={index}
                style={{ fontWeight: part.highlight ? 700 : 400 }}
              >
                {part.text}
              </span>
            ))}
          </div>
        );
      }}
      {...extraProps}
    />
  );
};
export default RBIAutocompleteSearch;
